import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/stores/auth";
import { LogOut, Mail, Phone, Building2 } from "lucide-react";

export const Route = createFileRoute("/_authed/profile")({
  head: () => ({ meta: [{ title: "Profile — Sura" }] }),
  component: ProfilePage,
});

function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  return (
    <div className="px-4 md:px-8 py-6 md:py-10 max-w-3xl mx-auto">
      <div className="flex items-center gap-5 mb-10">
        <div className="h-20 w-20 rounded-full bg-gradient-to-br from-primary to-primary/60 text-primary-foreground flex items-center justify-center text-2xl font-semibold">
          {user.full_name?.[0]?.toUpperCase()}
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">{user.full_name}</h1>
          <p className="text-muted-foreground text-sm">Sura member</p>
        </div>
      </div>

      <div className="space-y-3 mb-10">
        <Field icon={Mail} label="Email" value={user.email} />
        {user.phone_number && <Field icon={Phone} label="Phone" value={user.phone_number} />}
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Building2 className="h-5 w-5 text-primary" />
            <h2 className="font-semibold">Your business types</h2>
          </div>
          <button
            onClick={() => navigate({ to: "/onboarding" })}
            className="text-sm text-primary font-medium hover:underline"
          >
            Edit
          </button>
        </div>
        <div className="flex flex-wrap gap-2">
          {user.business_types?.length ? user.business_types.map((b) => (
            <span key={b.id} className="px-3 py-1.5 rounded-full bg-secondary text-sm">{b.name}</span>
          )) : <p className="text-sm text-muted-foreground">None selected yet.</p>}
        </div>
      </div>

      <button
        onClick={logout}
        className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-border text-destructive hover:bg-destructive/10 font-medium text-sm"
      >
        <LogOut className="h-4 w-4" /> Log out
      </button>
    </div>
  );
}

function Field({ icon: Icon, label, value }: { icon: any; label: string; value: string }) {
  return (
    <div className="flex items-center gap-4 px-4 py-3 bg-card border border-border rounded-xl">
      <Icon className="h-5 w-5 text-muted-foreground" />
      <div>
        <div className="text-xs text-muted-foreground">{label}</div>
        <div className="text-sm font-medium">{value}</div>
      </div>
    </div>
  );
}
